export default __webpack_public_path__ + "6fd47f3a878ab7c804383c1a07e08cdb.webp";